import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeSettingsContext = createContext();

export const ThemeSettingsProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => 
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  const [fontSize, setFontSize] = useState(16);

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      setDarkMode(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <ThemeSettingsContext.Provider value={{ darkMode, setDarkMode, fontSize, setFontSize }}>
      {children}
    </ThemeSettingsContext.Provider>
  );
};

export const useThemeSettings = () => useContext(ThemeSettingsContext); 